// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.v-input--selection-controls[data-v-e1294f20]{\n  margin-top:0\n}\n.v-input--selection-controls[data-v-e1294f20]  .v-input__slot{\n  margin-bottom:0!important\n}\n.v-input--selection-controls[data-v-e1294f20]  .v-messages{\n  display:none\n}\n[data-v-e1294f20] img.tx-gt3math-inline{\n  max-width:100%\n}\n.answerwidth[data-v-e1294f20]{\n  width:11.5rem\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
